<template >
  <!-- About Start -->
    <section id="unique" class="unique" >
      <div class="container">
        <div class="row ">
          <div class="column col-md-10">
                <h1 class="text-white">
                    <slot name="editing_platform"></slot>
                  </h1>
            
                  <div class="unique-container">
              <div class="unique-desc-container">

               <p><slot name="editing_platform_desc1"></slot></p>
                </div>

                <div class="unique-movie-container">

              <slot name="video_time_stampped"></slot>

              </div>
          </div>



            <div class="unique-container">
              <div
              class="unique-desc-container">

               <p><slot name="editing_platform_desc0"></slot></p>
                </div>

                <div class="unique-movie-container">

              <slot name="video_trimmed"></slot>

              </div>
          </div>

           <div class="unique-container">
                 <div
              class="unique-desc-container">
               <p><slot name="editing_platform_desc2"></slot></p>
                </div>

                <div class="unique-movie-container">

                   
                  <slot name="video_replace_all"></slot>
              </div>
          </div>

          <div class="unique-container">
                 <div
              class="unique-desc-container">
               <p><slot name="editing_platform_desc3"></slot></p>
                </div>

                <div class="unique-movie-container">

                    <slot name="video_add_dictionary"></slot>
              </div>
          </div>
          </div>
        </div>
      </div>
    </section>
    <!-- About End -->

</template>
<script>
export default {
  name: 'UniqueSection',
  data: () => ({
      videos:{

        'TimestamppedWord_en_US':'https://firebasestorage.googleapis.com/v0/b/taption-production.appspot.com/o/system%2FTimestamppedWord_en_US.mp4?alt=media&token=430b02c7-7990-48da-a99e-b951a8b51272',
        'TimestamppedWord_zh':'https://firebasestorage.googleapis.com/v0/b/taption-production-taiwan/o/system%2FTimestamppedWord_zh.mp4?alt=media&token=967a14ee-3d41-47c0-ac1c-c98ca0848242',
        'TimestamppedWord_zh_CN':'https://firebasestorage.googleapis.com/v0/b/taption-production-taiwan/o/system%2FTimestamppedWord_zh.mp4?alt=media&token=967a14ee-3d41-47c0-ac1c-c98ca0848242',
        
        'ReplaceAll_en_US':'https://firebasestorage.googleapis.com/v0/b/taption-production.appspot.com/o/system%2FReplaceAll_en_US.mp4?alt=media&token=b78912a4-8825-41b3-b622-00c672e5a618',
        'ReplaceAll_zh':'https://firebasestorage.googleapis.com/v0/b/taption-production-taiwan/o/system%2FReplaceAll_zh.mp4?alt=media&token=128b3f7d-e2be-4229-8912-c18ece8ad66a',
        'ReplaceAll_zh_CN':'https://firebasestorage.googleapis.com/v0/b/taption-production-taiwan/o/system%2FReplaceAll_zh.mp4?alt=media&token=128b3f7d-e2be-4229-8912-c18ece8ad66a',
        
        'AddToDictionary_en_US':'https://firebasestorage.googleapis.com/v0/b/taption-production.appspot.com/o/system%2FAddToDictionary_en_US.mp4?alt=media&token=88d04bac-cb75-4217-8959-174dceb884da',
        'AddToDictionary_zh':'https://firebasestorage.googleapis.com/v0/b/taption-production-taiwan/o/system%2FAddToDictionary_zh.mp4?alt=media&token=382d998f-289c-47de-91da-6ace60aff593',
        'AddToDictionary_zh_CN':'https://firebasestorage.googleapis.com/v0/b/taption-production-taiwan/o/system%2FAddToDictionary_zh.mp4?alt=media&token=382d998f-289c-47de-91da-6ace60aff593'
      },
      videoState:{
          video1:false,
          video2:false,
          video3:false  
      },
      timestamppedWordSrc:'https://firebasestorage.googleapis.com/v0/b/taption-production.appspot.com/o/system%2FReplaceAll_en_US.mp4?alt=media&token=b78912a4-8825-41b3-b622-00c672e5a618',
      replaceAllSrc:'https://firebasestorage.googleapis.com/v0/b/taption-production.appspot.com/o/system%2FReplaceAll_en_US.mp4?alt=media&token=b78912a4-8825-41b3-b622-00c672e5a618',
      addToDictionarySrc:'https://firebasestorage.googleapis.com/v0/b/taption-production.appspot.com/o/system%2FAddToDictionary_en_US.mp4?alt=media&token=5251e087-bdbd-4464-affc-1a4116489d3a',
  }),
  methods: {
    resetAll(){
      const me = this;
      me.stepsActive.first = false;
      me.stepsActive.second = false;
      me.stepsActive.third = false;
      me.stepsActive.forth = false;
    },
    onStepClicked(par){
      const me = this;
      me.resetAll();
      me.stepsActive[par] = true;
    },
    onLogin () {
      const me = this
      me.$router.push({ name: 'login' })
    },
    onClicked(videoType, isPlay){
        const me = this;
        me.$refs[videoType].play();
        me.videoState[videoType] = isPlay;
    } 
    // onEnded(){
    //     alert('wef');
    // }
  }
  // mounted(){
  //   const me = this;
  //   const language = window.localStorage.getItem('PrefferedLanguage').replace('-','_');
  //   me.timestamppedWordSrc = me.videos[`TimestamppedWord_${language}`];
  //   me.replaceAllSrc = me.videos[`ReplaceAll_${language}`];
  //   me.addToDictionarySrc = me.videos[`AddToDictionary_${language}`];

  //   const video1 = document.getElementById("video1");   
  //   const video2 = document.getElementById("video2");   
  //   const video3 = document.getElementById("video3");   

  //   video1.onended = function(e) {
  //       this.currentTime = 0;
  //       me.videoState.video1 = false;
  //   } 
  //   video2.onended = function(e) {
  //       me.videoState.video2 = false;
  //   } 
  //   video2.onloadedmetadata = function(e) {
  //       this.currentTime = this.duration;
  //       me.videoState.video2 = false;
  //   } 
  //   video3.onended = function(e) {
  //       me.videoState.video3 = false;
  //   } 
  //   video3.onloadedmetadata = function(e) {
  //       this.currentTime = this.duration;
  //       me.videoState.video3 = false;
  //   } 
  // }
}
</script>
<style scoped>
button.play {
  border-color: transparent transparent transparent #3ccebd;
  box-sizing: border-box;
  width: 74px;
  height: 74px;
  border-width: 37px 0px 37px 70px;
  transition: all .3s ease-in-out; ;
    position: absolute;
    top: calc(50% - 37px);
    left: calc(50% - 35px);
    border-style: solid;
    opacity:0.7;
}

.video-wrapper:hover button.play{
  border-color: transparent transparent transparent #00e0c6;
  
}
.unique .play-button img{
  width:76px;
  height:76px;
}
.unique .play-button{
  position: absolute;
  width:76px;
  height:76px;
    top: calc(50% - 38px);
    left: calc(50% - 38px);
}
.unique .play-button::before{
  box-shadow: 0 0 3px 3px #e8e8e8;
    position: absolute;
    content: "";
    width: 76px;
    height: 76px;
    bottom: auto;
    left: auto;
    border-radius: 50%;
    z-index: 0;
    -webkit-animation: none;
    animation: none;
}
</style>

<style>
.unique{
  background-image: url('../../assets/images/about.webp')!important;
  padding-bottom: 0px;
}
.unique .column {
    margin: 0 auto;
}
.unique-container {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    height: auto;
    display:flex;
}

.unique-desc-container {
   width:50%;
   height:100%;
   z-index:1;
   padding:70px 70px;
  text-align: center;
}

.unique-desc-container > p{
   font-size: 18px;
       line-height: 1.8em;
    color: #474343;
}
.unique-movie-container 
{
  width:50%;
  height:100%;
    -webkit-box-align: start;
    -ms-flex-align: start;
    align-items: flex-start;
  text-align: center;
}

#unique h2.title{
  margin-bottom: 10px!important;
  margin-top: 30px;
  
    line-height: 28px;
    font-size: 30px!important;
    font-weight: 300;
    margin-bottom: 32px;
    color: #444444;
    text-transform: uppercase;
    letter-spacing: 4px!important;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif!important;
}

.unique-video{
    margin: 0px auto;
    display: block;
    width: 100%;
    height: auto;
}
.video-wrapper{
    cursor: pointer;
    position:relative;
}
@media (max-width: 992px) {
    .unique-container {
        display:block;
        width: 100%;
        padding: 30px 0px;
    }
    .unique-desc-container{
        width:100%;
        padding:10px;
    }
    .unique-movie-container {
        width:100%;
    }
    .unique h1 {
        line-height: 60px;
    }
}
@media (max-width: 400px) {
}
</style>
